import React from "react";
import "./Terms.css";

const TermsScreen: React.FC = () => {
  return (
    <div className="terms-container container">
      <h1>Termos de Uso – Mimo Cupido</h1>
      <p className="terms-meta">
        <strong>Última atualização:</strong> Maio de 2026
      </p>

      <p>
        Estes Termos e Condições (“Termos de Uso”) têm por finalidade explicitar
        as regras e condições que irão orientar a utilização dos serviços
        oferecidos pela empresa <strong>66.154.541 SILVANA ALVES</strong>,
        inscrita no CNPJ sob nº <strong>66.154.541/0001-82</strong>, doravante
        denominada <strong>“Mimo Cupido”</strong>, por meio de sua plataforma e
        website oficial:{" "}
        <a
          href="https://www.mimocupido.com.br"
          target="_blank"
          rel="noreferrer"
        >
          www.mimocupido.com.br
        </a>
        .
      </p>

      <p>
        O uso da plataforma, website ou qualquer conteúdo nela disponibilizado
        sujeita o <strong>USUÁRIO</strong> à observância integral destes Termos
        de Uso e da Política de Privacidade do Mimo Cupido.
      </p>

      <p>
        Em caso de dúvidas, suporte ou solicitações, o <strong>USUÁRIO</strong>{" "}
        poderá entrar em contato através do e-mail oficial:{" "}
        <a href="mailto:atendimento@mimocupido.com">
          atendimento@mimocupido.com
        </a>
        .
      </p>

      <hr />

      <h2>Índice</h2>
      <ul>
        <li>Objeto</li>
        <li>Da Aceitação</li>
        <li>Definições Preliminares</li>
        <li>Cadastro e Uso de Dados Pessoais</li>
        <li>Compras pela Plataforma</li>
        <li>Política de Cancelamento e Reembolso</li>
        <li>Regras de Conduta</li>
        <li>Responsabilidade nas Interações</li>
        <li>Disponibilidade da Plataforma</li>
        <li>Links de Terceiros</li>
        <li>Propriedade Intelectual</li>
        <li>Segurança</li>
        <li>Alterações destes Termos</li>
      </ul>

      <hr />

      <h2>1. Objeto</h2>
      <p>
        O presente instrumento regulamenta a utilização da plataforma Mimo
        Cupido e o acesso aos serviços disponibilizados ao USUÁRIO.
      </p>
      <p>
        <strong>
          A plataforma Mimo Cupido contém conteúdo destinado exclusivamente para
          maiores de 18 (dezoito) anos, sendo expressamente proibido o acesso ou
          utilização por menores de idade.
        </strong>
      </p>
      <p>
        A plataforma possibilita que usuários criem perfis, conheçam outras
        pessoas, conversem, utilizem funcionalidades premium e contratem
        produtos e serviços disponibilizados pelo Mimo Cupido.
      </p>
      <p>
        O USUÁRIO é o único responsável pelas informações fornecidas em seu
        cadastro, podendo alterá-las, corrigí-las ou removê-las a qualquer
        momento através de sua conta ou canais oficiais de atendimento.
      </p>
      <p>
        O Mimo Cupido poderá realizar verificações de identidade e autenticidade
        das informações fornecidas para garantir maior segurança da plataforma.
        Informações falsas, incompletas ou suspeitas poderão resultar em
        suspensão ou exclusão da conta sem direito a reembolso.
      </p>
      <p>
        O Mimo Cupido busca manter um ambiente seguro e respeitoso, porém não
        garante a veracidade absoluta das informações fornecidas pelos usuários.
      </p>

      <div className="alerta-juridico">
        O MIMO CUPIDO NÃO É UM SITE DE ACOMPANHANTES E NÃO TOLERA QUALQUER
        CONDUTA RELACIONADA À PROSTITUIÇÃO, AGENCIAMENTO OU QUALQUER PRÁTICA
        ILEGAL.
      </div>

      <h2>2. Da Aceitação</h2>
      <p>
        Ao acessar, cadastrar-se ou utilizar a plataforma Mimo Cupido, o USUÁRIO
        declara que leu, compreendeu e aceitou integralmente estes Termos de Uso
        e a Política de Privacidade.
      </p>
      <p>
        O USUÁRIO declara possuir plena capacidade civil para assumir todas as
        obrigações aqui previstas.
      </p>
      <p>
        O descumprimento destes Termos poderá resultar no cancelamento imediato
        do acesso à plataforma, independentemente de aviso prévio.
      </p>

      <h2>3. Definições Preliminares</h2>
      <ul>
        <li>
          <strong>Cadastro:</strong> Ficha cadastral contendo os dados pessoais
          do USUÁRIO necessários para utilização da plataforma.
        </li>
        <li>
          <strong>Usuário:</strong> Pessoa física maior de 18 anos devidamente
          cadastrada na plataforma.
        </li>
        <li>
          <strong>Plataforma:</strong> Website e sistemas digitais do Mimo
          Cupido disponíveis em:{" "}
          <a
            href="https://www.mimocupido.com.br"
            target="_blank"
            rel="noreferrer"
          >
            www.mimocupido.com.br
          </a>
        </li>
        <li>
          <strong>Login:</strong> E-mail informado pelo usuário durante o
          cadastro.
        </li>
        <li>
          <strong>Senha:</strong> Código pessoal e sigiloso criado pelo usuário
          para acesso à plataforma.
        </li>
        <li>
          <strong>Produtos e Serviços:</strong> Funcionalidades, planos,
          assinaturas e recursos disponibilizados mediante pagamento.
        </li>
      </ul>

      <h2>4. Cadastro e Uso de Dados Pessoais</h2>
      <p>
        Para utilização da plataforma, o USUÁRIO deverá fornecer dados
        verdadeiros, completos e atualizados.
      </p>
      <p>
        O tratamento de dados pessoais será realizado em conformidade com a Lei
        Geral de Proteção de Dados (Lei nº 13.709/2018 – LGPD).
      </p>
      <p>Os dados poderão ser utilizados para:</p>
      <ul>
        <li>Funcionamento adequado da plataforma e autenticação do usuário;</li>
        <li>Segurança da conta e aproximação entre usuários;</li>
        <li>Comunicação de novidades, atualizações e promoções;</li>
        <li>Melhoria da experiência na plataforma.</li>
      </ul>
      <p>
        O usuário compromete-se a manter a confidencialidade de sua senha e
        acessos.
      </p>
      <p>
        <strong>
          É proibida a divulgação de: números de telefone, e-mails pessoais,
          redes sociais, dados bancários ou qualquer contato externo dentro do
          perfil.
        </strong>{" "}
        Perfis que violarem esta regra poderão ser suspensos.
      </p>

      <h2>5. Compras Pela Plataforma</h2>
      <p>
        O Mimo Cupido poderá disponibilizar produtos e serviços pagos,
        incluindo: Boost, Super Boost, Assinaturas Premium, Recursos exclusivos,
        Serviços de destaque de perfil e Análises prioritárias de cadastro.
      </p>
      <p>
        Todos os produtos digitais são considerados de uso imediato após sua
        ativação.
      </p>
      <h3>Assinaturas</h3>
      <p>
        As assinaturas poderão possuir renovação automática conforme o plano
        escolhido pelo usuário. Ao contratar uma assinatura, o usuário autoriza
        cobranças recorrentes até o cancelamento da renovação.
      </p>
      <p>
        O cancelamento deverá ser solicitado com antecedência mínima de 48 horas
        antes da próxima cobrança através do e-mail:
        <a href="mailto:atendimento@mimocupido.com">
          {" "}
          atendimento@mimocupido.com
        </a>
      </p>

      <h2>6. Política de Cancelamento e Reembolso</h2>
      <p>
        <strong>Não haverá reembolso nos seguintes casos:</strong>
      </p>
      <ul>
        <li>
          Serviços já utilizados ou recursos digitais consumidos parcial ou
          integralmente;
        </li>
        <li>Assinaturas promocionais ou de curta duração;</li>
        <li>Contas suspensas por violação destes Termos.</li>
      </ul>
      <p>
        <strong>Reembolso poderá ocorrer:</strong>
      </p>
      <ul>
        <li>
          Em até 7 dias corridos após a contratação, desde que o serviço não
          tenha sido utilizado e após análise da equipe financeira.
        </li>
      </ul>
      <p>
        Solicitações deverão ser enviadas para{" "}
        <a href="mailto:atendimento@mimocupido.com">
          atendimento@mimocupido.com
        </a>
        . O prazo de análise será de até 10 dias úteis.
      </p>

      <h2>7. Regras de Conduta</h2>
      <p>É proibido utilizar a plataforma para:</p>
      <ul>
        <li>Prostituição, agenciamento ou solicitação de dinheiro;</li>
        <li>Golpes, assédio, fraude ou atividades ilegais;</li>
        <li>Discurso de ódio, pornografia ilegal ou divulgação de menores;</li>
        <li>
          Spam, venda de produtos/serviços externos ou uso de robôs/automações;
        </li>
        <li>Invasões ou ataques ao sistema.</li>
      </ul>
      <p>
        O Mimo Cupido poderá remover conteúdos, bloquear usuários e colaborar
        com autoridades competentes sempre que necessário.
      </p>

      <h2>8. Responsabilidade nas Interações</h2>
      <p>
        O USUÁRIO é integralmente responsável por suas interações com outros
        usuários.
      </p>
      <p>
        O Mimo Cupido não garante a autenticidade dos perfis, a veracidade das
        informações ou a conduta dos usuários fora da plataforma.
      </p>
      <p>
        <strong>
          O usuário deve agir com cautela e nunca compartilhar informações
          financeiras ou sensíveis.
        </strong>
      </p>

      <h2>9. Disponibilidade da Plataforma</h2>
      <p>
        O Mimo Cupido busca manter sua plataforma continuamente disponível,
        porém não garante funcionamento ininterrupto. Falhas técnicas,
        manutenções, indisponibilidades de terceiros ou eventos de força maior
        poderão afetar temporariamente os serviços.
      </p>

      <h2>10. Links de Terceiros</h2>
      <p>
        A plataforma poderá conter links externos de terceiros. O Mimo Cupido
        não se responsabiliza pelo conteúdo, segurança ou políticas desses sites
        externos.
      </p>

      <h2>11. Propriedade Intelectual</h2>
      <p>
        Todo o conteúdo disponibilizado na plataforma — incluindo textos,
        imagens, logotipos, design, funcionalidades e marcas — pertence ao Mimo
        Cupido ou seus parceiros. É proibida qualquer reprodução, cópia,
        modificação ou exploração sem autorização prévia e expressa.
      </p>

      <h2>12. Segurança</h2>
      <p>
        O Mimo Cupido adota medidas técnicas e administrativas para proteção dos
        dados e da plataforma. Entretanto, o usuário também é responsável por
        proteger seus acessos, utilizar dispositivos seguros e manter sigilo de
        sua senha.
      </p>

      <h2>13. Alterações destes Termos</h2>
      <p>
        O Mimo Cupido poderá alterar estes Termos de Uso a qualquer momento,
        sendo recomendada a revisão periódica desta página. A continuidade de
        uso da plataforma após alterações representa concordância automática com
        os novos termos.
      </p>

      <hr />

      <h2>Contato Oficial</h2>
      <ul>
        <li>
          <strong>Website Oficial:</strong>{" "}
          <a
            href="https://www.mimocupido.com.br"
            target="_blank"
            rel="noreferrer"
          >
            www.mimocupido.com.br
          </a>
        </li>
        <li>
          <strong>E-mail Oficial:</strong>{" "}
          <a href="mailto:atendimento@mimocupido.com">
            atendimento@mimocupido.com
          </a>
        </li>
        <li>
          <strong>Empresa Responsável:</strong> 66.154.541 SILVANA ALVES
        </li>
        <li>
          <strong>CNPJ:</strong> 66.154.541/0001-82
        </li>
      </ul>
    </div>
  );
};

export default TermsScreen;
